import localforage from 'localforage';

export async function putIntoCache(key, value, expirationTime=0) {
  let wrapper;

  if (value !== null) {
    wrapper = { value };
  } else {
    wrapper = null;
  }

  if (wrapper && expirationTime) {
    wrapper.expireAfter = Date.now() + expirationTime * 1000;
  }

  return localforage.setItem(`__cache-${key}`, wrapper);
}

export async function getFromCache(key) {
  return localforage.getItem(`__cache-${key}`)
    .then(wrapper => {
      let notFound = !wrapper;
      let expired = !notFound && wrapper.expireAfter && wrapper.expireAfter <= Date.now();

      if (notFound || expired) return null;

      return wrapper.value;
    });
}
